import React from 'react';

const PlusIcon = ({
    width = 20,
    height = 20,
    fill = 'none',
    stroke = '#0053A0',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15 10H10M10 10H5M10 10V5M10 10V15"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PlusIcon;
